export default __webpack_public_path__ + "static/media/TrainerExl.e5aaa751.xlsx";